import styled, { css } from 'styled-components';
import FullScreenLoader from './Loader/FullScreenLoader';
import FullScreenAlert from './Alert/FullScreenAlert';

const PageWithAsyncDataWrapper = styled.div<{ noScroll?: boolean }>`
  min-height: 100vh;

  ${({ noScroll }) =>
    noScroll &&
    css`
      overflow: hidden;
      height: 100vh;
    `}

  animation: fadeIn 1s ease-in-out forwards;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  background-color: ${({ theme }) => theme.colors.bgPage};
`;

export default function PageWithAsyncData({
  error,
  isLoading,
  retry,
  children,
  className,
  noScroll,
}: {
  error: Error | null | unknown;
  isLoading: boolean;
  retry: () => void;
  children: React.ReactNode;
  className?: string;
  noScroll?: boolean;
}) {
  if (isLoading) {
    return <FullScreenLoader />;
  }

  if (error) {
    // special handling for axios errors
    // @ts-expect-error axios typing
    const text = error?.response
      ? // @ts-expect-error axios typing
        `${error?.response?.status} | ${error?.response?.data?.message}`
      : // @ts-expect-error axios typing
        error.message;

    return <FullScreenAlert onRetry={retry} text={text} />;
  }

  return (
    <PageWithAsyncDataWrapper className={className} noScroll={noScroll}>
      {children}
    </PageWithAsyncDataWrapper>
  );
}
